import React, { useEffect, useRef, useState } from 'react'
import st from './Deals.module.scss'
import MultiActionMenu from 'components/CRM/UI/components/MultiActionMenu/MultiActionMenu'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import asideModalStore from 'Stores/asideModalStore'
import DealsCardAppearance from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/DealsCardAppearance/DealsCardAppearance'
import useWindowWidth from 'components/CRM/utils/hooks/useWindowWidth'
import { superAxiosRequest } from 'axiosApi'
import AddNewDeal from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddNewDeal/AddNewDeal'
import Button from 'components/CRM/UI/components/Button/Button'
import { observer } from 'mobx-react'
import { useHistory, useLocation } from 'react-router-dom'
import Loader from 'components/UI/Loader/Loader'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import ColumnDeals from './ColumnDeals/ColumnDeals'
import ReasonRejectModal from './DealsCard/ReasonRejectModal/ReasonRejectModal'
import RequiredFieldsPaidModal from './DealsCard/RequiredFieldsConsultedModal/RequiredFieldsPaidModal'
import RequiredFieldsConsultedModal from './DealsCard/RequiredFieldsPaidModal/RequiredFieldsConsultedModal'
import MergeDealsForm from './MergeDealsForm/MergeDealsForm'
import MassEditDealsForm from './MassEditDealsForm/MassEditDealsForm'
import swal from 'sweetalert'
import RequiredFieldsModal from './DealsCard/RequiredFieldsModal/RequiredFieldsModal'

const Deals = () => {
  const windowWidth = useWindowWidth()
  const [sources, setSources] = useState([])

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      set_up_funnel: 'Set up a funnel',
      new_deals: 'New Deals',
      search_placeholder: 'Search',
      deals: 'Deals',
      import: 'Import',
      export: 'Export',
      card_appearance: 'Card appearance',
      search_duplicates: 'Search for duplicates',
      mass_actions: 'Mass actions',
      sorting: 'Sorting',
      by_creation_date: 'By creation date',
      by_name: 'By name',
      by_budget: 'By budget',
      auto_update: 'Auto update',
      by_status: 'By status',
      all_branches: 'All branches',
      city: 'City',
      quick_add: 'QUICK ADD',
      deal_name: 'Deal name',
      responsible: 'Responsible',
      enable_feature_x: 'Enable Feature X',
      new_deal: 'New deal',
      creating_new_deal: 'Creating a new deal',
      add_new_task: 'Add a new task',
      no_name: 'No name',
      reason_reject: 'Reason for refusal',
    },
  })

  const [reasons, setReasons] = useState(null)
  const [sourceData, setSourceData] = useState(null)

  const fetchSource = async () => {
    try {
      const { data } = await superAxiosRequest({
        link: `settings/project_settings/deal_source_choices`,
        method: 'get',
        crm: true,
      })
      if (data?.value?.choices) {
        setSourceData(data.value.choices)
      }
    } catch (error) {
      console.error('Ошибка загрузки:', error)
    }
  }
  const fetchReasons = async () => {
    try {
      const { data } = await superAxiosRequest({
        link: `settings/project_settings/deal_reject_reason_choices`,
        method: 'get',
        crm: true,
      })
      if (data?.value?.choices) {
        setReasons(data.value.choices)
      }
    } catch (error) {
      console.error('Ошибка загрузки причин:', error)
    }
  }

  useEffect(() => {
    fetchReasons()
    fetchSource()
  }, [])

  const filterCfg = [
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
    },
    {
      type: 'select-multi',
      apiLinkCRM: 'integration/deal_statuses/?not_id=1',
      nameState: 'status_deal',
      label: translate?.by_status,
      placeholder: translate?.by_status,
    },
    {
      label: translate?.deal_name,
      nameState: 'deal_name',
      type: 'input',
      placeholder: translate?.deal_name,
    },
    {
      type: 'select-multi',
      apiLinkCRM: 'integration/employees/?short_form=true',
      nameState: 'manager',
      label: translate?.responsible,
      placeholder: translate?.responsible,
    },
    {
      type: 'select-multi',
      apiLinkCRM: 'integration/cities',
      nameState: 'city',
      label: translate?.city,
      placeholder: translate?.city,
    },
    {
      type: 'select-multi',
      apiLinkCRM: 'integration/branches',
      nameState: 'branch',
      label: translate?.all_branches,
      placeholder: translate?.all_branches,
    },
    {
      type: 'select-multi',
      label: 'Источник',
      placeholder: 'Источник',
      values: sources.map((el) => ({
        id: el.id,
        name: `${el.name} ${el.comment ?? ''}`,
      })),
      sort_key: 'name',
      nameState: 'source_id',
    },
    {
      type: 'select-multi',
      label: 'Откуда пришли',
      placeholder: 'Откуда пришли',
      values: sourceData?.map((el) => ({
        id: el.name,
        name: el.name,
      })),
      sort_key: 'name',
      nameState: 'source',
    },
    {
      type: 'select-multi',
      label: translate?.reject_reason || 'Причина отказа',
      placeholder: translate?.reject_reason || 'Причина отказа',
      values: reasons?.map((el) => ({
        id: el.name,
        name: el.name,
      })),
      sort_key: 'name',
      nameState: 'reject_reason',
    },
  ]

  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // Состояние для выбранных сделок
  const [selectedDeals, setSelectedDeals] = useState([])

  // Состояние для модального окна объединения
  const [isMergeModalOpen, setIsMergeModalOpen] = useState(false)

  // Состояние для модального окна массовых изменений
  const [isMassEditModalOpen, setIsMassEditModalOpen] = useState(false)

  // Состояние для данных выбранных сделок
  const [dealsForAction, setDealsForAction] = useState([])

  // Состояние загрузки данных
  const [isLoadingActionData, setIsLoadingActionData] = useState(false)

  // Функция для выбора/снятия выбора сделки
  const toggleDealSelection = (dealId) => {
    setSelectedDeals((prev) => {
      if (prev.includes(dealId)) {
        return prev.filter((id) => id !== dealId)
      } else {
        return [...prev, dealId]
      }
    })
  }

  // Функция для получения данных выбранных сделок
  const fetchDealsForAction = async (actionType) => {
    if (selectedDeals.length < 2) return

    setIsLoadingActionData(true)
    try {
      const promises = selectedDeals.map((dealId) =>
        superAxiosRequest({
          link: `integration/deals/${dealId}`,
          method: 'get',
          crm: true,
        }),
      )

      const responses = await Promise.all(promises)
      const dealsData = responses.map((response) => response.data)
      setDealsForAction(dealsData)

      if (actionType === 'merge') {
        setIsMergeModalOpen(true)
      } else if (actionType === 'massEdit') {
        setIsMassEditModalOpen(true)
      }
    } catch (error) {
      console.error('Error fetching deals:', error)
      swal('Ошибка!', 'Не удалось загрузить данные сделок', 'error')
    } finally {
      setIsLoadingActionData(false)
    }
  }

  // Закрытие модальных окон
  const closeMergeModal = () => {
    setIsMergeModalOpen(false)
    setDealsForAction([])
  }

  const closeMassEditModal = () => {
    setIsMassEditModalOpen(false)
    setDealsForAction([])
  }

  // Очистка выбора сделок
  const clearSelection = () => {
    setSelectedDeals([])
  }

  // Функция объединения сделок
  const handleMerge = async (payload) => {
    try {
      const response = await superAxiosRequest(
        {
          link: 'integration/deals_combine',
          method: 'post',
          crm: true,
        },
        payload,
      )

      closeMergeModal()
      clearSelection()
      clearData()
      swal('Успех!', 'Сделки успешно объединены!', 'success')
    } catch (error) {
      console.error('Ошибка при объединении сделок:', error)
      swal('Ошибка!', 'Не удалось объединить сделки', 'error')
    }
  }

  // Функция массового обновления сделок
  const handleMassEdit = async (payload) => {
    try {
      const response = await superAxiosRequest(
        {
          link: 'integration/bulk_update_deals',
          method: 'post',
          crm: true,
        },
        payload,
      )

      closeMassEditModal()
      clearSelection()
      clearData()
      refreshAllColumns()
      swal(
        'Успех!',
        `Изменения применены к ${payload.deal_ids.length} сделкам`,
        'success',
      )
    } catch (error) {
      console.error('Ошибка при массовом обновлении:', error)
      swal('Ошибка!', 'Не удалось применить изменения', 'error')
    }
  }

  const refreshAllColumns = () => {
    visibleColumns.forEach((column) => {
      refreshColumnCompletely(column.id)
    })
  }

  // Компонент кнопки объединения (только для 2-5 сделок)
  const MergeButton = () => {
    if (selectedDeals.length < 2 || selectedDeals.length > 5) return null

    return (
      <Button
        text={`Объединить сделки (${selectedDeals.length})`}
        onClick={() => fetchDealsForAction('merge')}
        withIcon
      />
    )
  }

  // Компонент кнопки массовых изменений (для 2+ сделок)
  const MassEditButton = () => {
    if (selectedDeals.length < 2) return null

    return (
      <Button
        text={`Массовые изменения (${selectedDeals.length})`}
        onClick={() => fetchDealsForAction('massEdit')}
        withIcon
      />
    )
  }

  // Компонент кнопки очистки выбора
  const ClearSelectionButton = () => {
    if (selectedDeals.length === 0) return null

    return (
      <Button
        text={`Очистить выбор (${selectedDeals.length})`}
        onClick={clearSelection}
        whiteBtn
      />
    )
  }

  // -----------------------------------------------------------------------------------------------------------------------------------------------

  const [filter, updateFilter] = useLocalStorageFilter()
  const history = useHistory()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [dealsMap, setDealsMap] = useState({})
  const [totalMap, setTotalMap] = useState({})
  const [page, setPage] = useState({})
  const [columns, setColumns] = useState([])
  const [loading, setLoading] = useState(false)
  const [autoupdate, setAutoupdate] = useState(false)

  const [funnels, setFunnels] = useState([])
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const funnelId = searchParams.get('funnel_id')

  const [checked, setChecked] = useState(() => {
    return JSON.parse(localStorage.getItem('auto_update_crm')) || false
  })
  const [sortOrder, setSortOrder] = useState('created_at')

  const [pendingDragData, setPendingDragData] = useState(null)

  // Безопасное извлечение массива ID из фильтра
  const getSelectedStatusIds = React.useMemo(() => {
    if (!filter?.status_deal) return []
    if (Array.isArray(filter.status_deal)) {
      return filter.status_deal
        .map((s) => (typeof s === 'object' && s !== null ? s.id : s))
        .filter((id) => id !== undefined && id !== null)
    }
    const singleId =
      typeof filter.status_deal === 'object' && filter.status_deal !== null
        ? filter.status_deal.id
        : filter.status_deal
    return singleId !== undefined && singleId !== null ? [singleId] : []
  }, [filter?.status_deal])

  // Оставляем только те колонки, которые выбраны в фильтре
  const visibleColumns = React.useMemo(() => {
    if (getSelectedStatusIds.length === 0) return columns
    return columns.filter((col) => getSelectedStatusIds.includes(col.id))
  }, [columns, getSelectedStatusIds])

  // Создаем фильтр без status_deal для передачи в ColumnDeals
  const filterForColumns = React.useMemo(() => {
    if (!filter) return {}
    const { status_deal, ...rest } = filter
    return rest
  }, [filter])

  // Конфигурация колонок с их ID и обязательными полями
  const columnConfig = {
    // 14: {
    //   type: 'reject',
    //   requiredFields: ['reject_reason'],
    //   modalComponent: ReasonRejectModal,
    // },
    // 65: {
    //   type: 'consulted',
    //   requiredFields: ['budget', 'city', 'branch', 'program', 'source'],
    //   modalComponent: RequiredFieldsConsultedModal,
    // },
    // 13: {
    //   type: 'paid',
    //   requiredFields: [
    //     'is_application_signed',
    //     'learning_type',
    //     'education_type',
    //     'learning_goal',
    //     'learning_days',
    //   ],
    //   modalComponent: RequiredFieldsPaidModal,
    // },
    // 66: {
    //   type: 'standard',
    //   requiredFields: ['manager', 'budget', 'city', 'branch', 'program'],
    //   modalComponent: RequiredFieldsModal,
    // },
    // 67: {
    //   type: 'standard',
    //   requiredFields: ['manager', 'budget', 'city', 'branch', 'program'],
    //   modalComponent: RequiredFieldsModal,
    // },
    // 68: {
    //   type: 'standard',
    //   requiredFields: ['manager', 'budget', 'city', 'branch', 'program'],
    //   modalComponent: RequiredFieldsModal,
    // },
    // 69: {
    //   type: 'standard',
    //   requiredFields: ['manager', 'budget', 'city', 'branch', 'program'],
    //   modalComponent: RequiredFieldsModal,
    // },
    // 82: {
    //   type: 'standard',
    //   requiredFields: ['manager', 'budget', 'city', 'branch', 'program'],
    //   modalComponent: RequiredFieldsModal,
    // },
    // 89: {
    //   type: 'standard',
    //   requiredFields: ['manager', 'budget', 'city', 'branch', 'program'],
    //   modalComponent: RequiredFieldsModal,
    // },
  }

  const isSpecialColumn = (columnId) => {
    return columnConfig[columnId] !== undefined
  }

  const getColumnType = (columnId) => {
    return columnConfig[columnId]?.type || null
  }

  const getRequiredFieldsForColumn = (columnId) => {
    return columnConfig[columnId]?.requiredFields || []
  }

  const hasRequiredFields = (deal, targetColumnId) => {
    const requiredFields = getRequiredFieldsForColumn(targetColumnId)

    if (requiredFields.length === 0) return true

    return requiredFields.every((field) => {
      const value = deal[field]
      return value !== undefined && value !== null && value !== ''
    })
  }

  const openRequiredFieldsModal = (deal, targetColumnId) => {
    const config = columnConfig[targetColumnId]

    if (!config) return

    const ModalComponent = config.modalComponent
    const requiredFields = config.requiredFields

    const valid = {}
    requiredFields.forEach((field) => {
      valid[field] = 'required'
    })

    const md = {
      deal_name: deal.deal_name,
      manager: deal.manager?.id,
      client: deal.client?.id,
      budget: deal.budget,
      city: deal.city?.id,
      branch: deal.branch?.id,
      program: deal.program?.id,
      source: deal.source,
      funnels: [funnelId],
    }

    if (config.type === 'paid') {
      md.is_application_signed = deal?.is_application_signed
      md.learning_type = deal?.learning_type
      md.education_type = deal?.education_type
      md.learning_goal = deal?.learning_goal
      md.learning_days = deal?.learning_days
    }

    const ms = {
      modalBodyComponent: () => <ModalComponent />,
      button: 'Save',
      link: `integration/deals/${deal.id}`,
      title: getModalTitle(targetColumnId),
      is_put: true,
      isResponsive: true,
      crm: true,
      onSubmitSuccess: (responseData) =>
        moveDealAfterValidation(deal.id, targetColumnId, responseData),
      valid: valid,
    }

    asideModalStore.activity(ms, md)
  }

  const getModalTitle = (columnId) => {
    const titles = {
      14: 'Add reason for refusal',
      65: 'Заполните обязательные поля',
      13: 'Заполните информацию об обучении',
    }
    return titles[columnId] || 'Заполните обязательные поля'
  }

  const clearData = () => {
    setDealsMap({})
    setPage({})
  }

  const moveDealAfterValidation = (dealId, targetColumnId, updatedDeal) => {
    const sourceColumnId = Object.keys(dealsMap).find((colId) =>
      dealsMap[colId]?.some((deal) => deal.id === dealId),
    )

    if (!sourceColumnId) return

    const deal = dealsMap[sourceColumnId].find((d) => d.id === dealId)
    if (!deal) return

    const mergedDeal = { ...deal, ...updatedDeal }

    let targetIndex = 0
    if (pendingDragData && pendingDragData.targetColumnId === targetColumnId) {
      targetIndex = pendingDragData.targetIndex
    }

    setDealsMap((prev) => ({
      ...prev,
      [sourceColumnId]: prev[sourceColumnId].filter((el) => el.id !== dealId),
      [targetColumnId]: addElementAtIndex(
        prev[targetColumnId] || [],
        targetIndex,
        mergedDeal,
      ),
    }))

    setTotalMap((prev) => ({
      ...prev,
      [sourceColumnId]: {
        ...prev[sourceColumnId],
        total: (prev[sourceColumnId]?.total || 0) - 1,
        budgetSum: (prev[sourceColumnId]?.budgetSum || 0) - (deal.budget || 0),
      },
      [targetColumnId]: {
        ...prev[targetColumnId],
        total: (prev[targetColumnId]?.total || 0) + 1,
        budgetSum:
          (prev[targetColumnId]?.budgetSum || 0) + (mergedDeal.budget || 0),
      },
    }))

    superAxiosRequest(
      {
        link: `integration/deals/${dealId}/change_status_deal`,
        method: 'post',
        crm: true,
      },
      {
        new_deal_status_id: targetColumnId,
        funnel_id: funnelId,
      },
    )
      .then(() => {
        refreshColumnCompletely(targetColumnId)
        setPendingDragData(null)
      })
      .catch((error) => {
        console.error('Error changing deal status:', error)
      })
  }

  const handleDragEnd = (result) => {
    const { source, destination } = result

    if (!destination) return

    const start = +source.droppableId
    const finish = +destination.droppableId

    const isTargetSpecialColumn = isSpecialColumn(finish)

    if (source.droppableId !== destination.droppableId) {
      const selectedDeal = dealsMap[start]?.[source.index]

      if (!selectedDeal) return

      if (isTargetSpecialColumn && !hasRequiredFields(selectedDeal, finish)) {
        setPendingDragData({
          deal: selectedDeal,
          sourceColumnId: start,
          sourceIndex: source.index,
          targetColumnId: finish,
          targetIndex: destination.index,
        })

        openRequiredFieldsModal(selectedDeal, finish)
        return
      }

      moveDealImmediately(
        start,
        finish,
        selectedDeal,
        source.index,
        destination.index,
      )
    }
  }

  const moveDealImmediately = (
    start,
    finish,
    selectedDeal,
    sourceIndex,
    destinationIndex,
  ) => {
    setDealsMap((prev) => ({
      ...prev,
      [start]: prev[start]?.filter((el, index) => index !== sourceIndex) || [],
      [finish]: addElementAtIndex(
        prev[finish] || [],
        destinationIndex,
        selectedDeal,
      ),
    }))

    setTotalMap((prev) => ({
      ...prev,
      [start]: {
        ...prev[start],
        total: (prev[start]?.total || 0) - 1,
        budgetSum: (prev[start]?.budgetSum || 0) - (selectedDeal.budget || 0),
      },
      [finish]: {
        ...prev[finish],
        total: (prev[finish]?.total || 0) + 1,
        budgetSum: (prev[finish]?.budgetSum || 0) + (selectedDeal.budget || 0),
      },
    }))

    superAxiosRequest(
      {
        link: `integration/deals/${selectedDeal.id}/change_status_deal`,
        method: 'post',
        crm: true,
      },
      {
        new_deal_status_id: finish,
        funnel_id: funnelId,
      },
    )
      .then(() => {
        refreshColumnCompletely(finish)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const refreshColumnCompletely = (columnId) => {
    setPage((prev) => ({
      ...prev,
      [columnId]: 0,
    }))

    const queryParams = {
      ...filterForColumns,
      funnel_id: funnelId,
      order_by: sortOrder,
      offset: 0,
      status_deal: columnId,
    }

    superAxiosRequest({
      link: 'integration/deals',
      method: 'get',
      crm: true,
      params: queryParams,
    })
      .then((response) => {
        setDealsMap((prev) => ({
          ...prev,
          [columnId]: response.data.result || [],
        }))

        setTotalMap((prev) => ({
          ...prev,
          [columnId]: {
            total: response.data._meta?.count_items || 0,
            budgetSum: response.data._meta?.total_price?.budget__sum || 0,
          },
        }))
      })
      .catch(() => {})
  }

  useEffect(() => {
    const handleModalClose = () => {
      if (pendingDragData) {
        setPendingDragData(null)
      }
    }

    return () => {
      setPendingDragData(null)
    }
  }, [pendingDragData])

  const resetFilter = (key) => {
    if (!filter) return

    const { [key]: _, ...rest } = filter
    updateFilter(rest)
    changeTextValue(key, null)
    setTextValues(filterTextValues.filter((field) => field.key !== key))
  }

  const handleStatusDealFilter = (statusId) => {
    const selectedStatus = columns.find((column) => column.id === statusId)

    if (selectedStatus) {
      if (
        getSelectedStatusIds.length === 1 &&
        getSelectedStatusIds[0] === statusId
      ) {
        resetFilter('status_deal')
      } else {
        updateFilter({ ...filter, status_deal: statusId })
        changeTextValue('status_deal', {
          key: 'status_deal',
          label: translate?.by_status || 'By status',
          value: selectedStatus.name,
        })
      }
    }
  }

  useEffect(() => {
    setLoading(true)
    clearData()
    superAxiosRequest({
      link: 'integration/deal_statuses',
      method: 'get',
      crm: true,
      params: {
        funnel_id: funnelId,
      },
    })
      .then((response) => {
        const statusesArray = Object.values(response.data).sort(
          (a, b) => a.position - b.position,
        )
        setColumns(statusesArray)
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }, [filter])

  useEffect(() => {
    let isMounted = true

    superAxiosRequest({
      link: 'integration/funnels',
      method: 'get',
      crm: true,
      params: {
        my_onlyfunns: true,
      },
    })
      .then((res) => {
        setFunnels(res.data)
      })
      .catch(() => {})
      .finally(() => {})

    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    let isMounted = true

    superAxiosRequest({
      link: 'integration/sources',
      method: 'get',
      crm: true,
    })
      .then((res) => {
        setSources(res.data)
      })
      .catch(() => {})
      .finally(() => {})

    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('auto_update_crm', JSON.stringify(checked))
    if (checked) {
      const intervalId = setInterval(() => {
        clearData()
        setAutoupdate((prev) => !prev)
      }, 400000)
      return () => clearInterval(intervalId)
    }
  }, [checked, sortOrder])

  const handleCheckboxChange = () => {
    setChecked(!checked)
  }

  const menu = [
    { name: translate.import, action: 'import' },
    { name: translate.export, action: 'export' },
    { name: translate.card_appearance, action: 'card_appearance' },
    { name: translate.search_duplicates, action: 'search_for_duplicates' },
    { name: translate.mass_actions, action: 'mass_actions' },
    { line: true },
    { title: translate.sorting },
    { name: translate.by_creation_date, action: 'byDate' },
    { name: translate.by_name, action: 'byName' },
    { name: translate.by_budget, action: 'byBudget' },
    { line: true },
    {
      name: translate.enable_feature_x,
      action: 'enable_feature_x',
      checkbox: {
        label: translate.auto_update,
        value: checked,
        onChange: handleCheckboxChange,
      },
    },
  ]

  const menuMobile = [
    { name: translate.new_deal, action: 'new_deal' },
    { name: translate.set_up_funnel, action: 'set_up_funnel' },
    { line: true },
    ...menu,
  ]

  const addNewDealModal = () => {
    const ms = {
      modalBodyComponent: () => <AddNewDeal />,
      button: translate?.save,
      link: 'integration/deals',
      title: translate?.creating_new_deal,
      isResponsive: true,
      crm: true,
      onSubmitSuccess: (data) => {
        setDealsMap((prev) => ({
          ...prev,
          [columns[0].id]: [
            ...[
              {
                budget: data.budget,
                city: data.city,
                client: data.client,
                client_text_name: data.client_text_name,
                created_at: data.created_at,
                deal_name: data.deal_name,
                funnels: data.funnels,
                id: data.id,
                manager: data.manager,
                program: data.program,
              },
            ],
            ...prev[columns[0].id],
          ],
        }))
      },
      valid: {},
    }
    const md = {
      program: null,
      manager: null,
      branch: null,
      funnels: [funnelId],
    }
    asideModalStore.activity(ms, md)
  }

  const funnelPage = () => {
    return history.push(`/crm/funnels/?funnel_id=${funnelId}`)
  }

  const cardAppearance = () => {
    const ms = {
      modalBodyComponent: () => <DealsCardAppearance />,
      button: translate.save,
      link: '',
      title: translate.add_new_task,
      onSubmitSuccess: () => {},
      isResponsive: true,
      valid: {},
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const updateSortOrder = (orderBy) => {
    setSortOrder(orderBy)
    clearData()
  }

  const action = (action) => {
    switch (action) {
      case 'new_deal':
        addNewDealModal()
        break
      case 'set_up_funnel':
        funnelPage()
        break
      case 'import':
        break
      case 'export':
        break
      case 'card_appearance':
        break
      case 'search_for_duplicates':
        history.push('/crm/double')
        break
      case 'mass_actions':
        break
      case 'byDate':
        updateSortOrder('created_at')
        break
      case 'byName':
        updateSortOrder('deal_name')
        break
      case 'byBudget':
        updateSortOrder('budget')
        break
      case 'enable_feature_x':
        break
      default:
        break
    }
  }

  const addElementAtIndex = (array, index, element) => {
    return [
      ...(array?.slice(0, index) || []),
      element,
      ...(array?.slice(index) || []),
    ]
  }

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== `/crm/deals/?funnel_id=${funnelId}`) {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const menuItems = funnels.map((funnel) => ({
    name: funnel.name,
    action: `navigate_to_funnel_${funnel.id}`,
  }))

  const createActionFunction = (funnelId) => {
    return () => {
      window.location.href = `/crm/deals/?funnel_id=${funnelId}`
    }
  }

  const actionFunctions = {}
  funnels.forEach((funnel) => {
    actionFunctions[`navigate_to_funnel_${funnel.id}`] = createActionFunction(
      funnel.id,
    )
  })

  const [scrollLeft, setScrollLeft] = useState(0)
  const [scrollWidth, setScrollWidth] = useState(0)
  const [clientWidth, setClientWidth] = useState(0)
  const [isDragging, setIsDragging] = useState(false)
  const [startX, setStartX] = useState(0)

  const containerRef = useRef(null)
  const thumbRef = useRef(null)

  useEffect(() => {
    const updateScrollData = () => {
      if (containerRef.current) {
        const newScrollWidth = containerRef.current.scrollWidth
        const newClientWidth = containerRef.current.clientWidth

        if (scrollWidth !== newScrollWidth || clientWidth !== newClientWidth) {
          setScrollWidth(newScrollWidth)
          setClientWidth(newClientWidth)
        }
      }
    }

    const observer = new MutationObserver(updateScrollData)

    if (containerRef.current) {
      updateScrollData()
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      })
    }

    window.addEventListener('resize', updateScrollData)

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', updateScrollData)
    }
  }, [dealsMap, columns, windowWidth])

  useEffect(() => {
    const handleGlobalMouseMove = (e) => {
      if (!isDragging || !containerRef.current || !thumbRef.current) return

      const track = thumbRef.current.parentElement
      const trackRect = track.getBoundingClientRect()
      const thumbWidth = thumbRef.current.offsetWidth

      let newLeft = e.clientX - trackRect.left - startX
      newLeft = Math.max(0, Math.min(trackRect.width - thumbWidth, newLeft))

      const scrollRatio = newLeft / (trackRect.width - thumbWidth)
      const newScrollLeft = scrollRatio * (scrollWidth - clientWidth)

      containerRef.current.scrollLeft = newScrollLeft
    }

    const handleGlobalMouseUp = () => {
      setIsDragging(false)
    }

    if (isDragging) {
      window.addEventListener('mousemove', handleGlobalMouseMove)
      window.addEventListener('mouseup', handleGlobalMouseUp)
    }

    return () => {
      window.removeEventListener('mousemove', handleGlobalMouseMove)
      window.removeEventListener('mouseup', handleGlobalMouseUp)
    }
  }, [isDragging, scrollWidth, clientWidth, startX])

  const handleScroll = (e) => {
    const container = e.target
    const maxScrollLeft = container.scrollWidth - container.clientWidth

    const newScrollLeft = Math.max(
      0,
      Math.min(container.scrollLeft, maxScrollLeft),
    )

    if (newScrollLeft !== container.scrollLeft) {
      container.scrollLeft = newScrollLeft
    }

    setScrollLeft(newScrollLeft)
  }

  const handleThumbMouseDown = (e) => {
    if (e.button !== 0) return

    setIsDragging(true)
    setStartX(e.nativeEvent.offsetX)
    e.preventDefault()
    e.stopPropagation()
  }

  const handleTrackClick = (e) => {
    if (!containerRef.current || !thumbRef.current) return

    const track = e.currentTarget
    const trackRect = track.getBoundingClientRect()
    const thumbWidth = thumbRef.current.offsetWidth

    const clickPosition =
      (e.clientX - trackRect.left - thumbWidth / 2) /
      (trackRect.width - thumbWidth)
    const normalizedPosition = Math.max(0, Math.min(1, clickPosition))

    containerRef.current.scrollLeft =
      normalizedPosition * (scrollWidth - clientWidth)
  }

  const handleSelectAllInColumn = (columnId, dealsInColumn) => {
    if (!dealsInColumn || dealsInColumn.length === 0) return

    const allSelected = dealsInColumn.every((deal) =>
      selectedDeals.includes(deal.id),
    )

    if (allSelected) {
      setSelectedDeals((prev) =>
        prev.filter((id) => !dealsInColumn.some((deal) => deal.id === id)),
      )
    } else {
      const newSelectedIds = dealsInColumn
        .filter((deal) => !selectedDeals.includes(deal.id))
        .map((deal) => deal.id)

      setSelectedDeals((prev) => [...prev, ...newSelectedIds])
    }
  }

  const totalDealsCount = React.useMemo(() => {
    if (getSelectedStatusIds.length > 0) {
      return getSelectedStatusIds.reduce((sum, id) => {
        return sum + (totalMap[id]?.total || 0)
      }, 0)
    }
    return Object.values(totalMap).reduce((sum, column) => {
      return sum + (column?.total || 0)
    }, 0)
  }, [totalMap, getSelectedStatusIds])

  return (
    <div className={st.container}>
      <div className={st.dealsHeader}>
        <div className={st.header}>
          <div className={st.titleBlock}>
            <h1 className={st.title}>
              {funnels.filter((f) => f.id === +funnelId)[0]?.name}
            </h1>
            <ActionMenu
              iconType={'arrow'}
              menu={menuItems}
              action={(actionName) => {
                const actionFunction = actionFunctions[actionName]
                if (actionFunction) {
                  actionFunction()
                }
              }}
              right
            />
          </div>

          {windowWidth < 768 ? (
            <MultiActionMenu
              menu={menuMobile}
              action={action}
              sortOrder={sortOrder}
            />
          ) : (
            <div className={st.dealHeadBtn}>
              <div className={st.dealCountWrapper}>
                <span className={st.dealCountLabel}>Сделок:</span>
                <span className={st.dealCountValue}>{totalDealsCount}</span>
              </div>
              <div className={st.dealHeadBtn__divider}></div>
              <MultiActionMenu
                menu={menu}
                action={action}
                sortOrder={sortOrder}
              />

              <div className={st.dealHeadBtn__divider}></div>

              <MergeButton />
              <MassEditButton />
              <ClearSelectionButton />

              <Button
                to={`/crm/funnels/?funnel_id=${funnelId}`}
                text={translate.set_up_funnel}
                withIcon
              />
              <Button
                text={translate.new_deal}
                onClick={addNewDealModal}
                withIcon
              />
            </div>
          )}
        </div>
        <div className={st.searchFilterValues}>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, search: text })
              changeTextValue('search', {
                key: 'search',
                label: translate.search,
                value: text,
              })
            }}
            onClear={() => {
              const { search, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'search'),
              )
            }}
            translate={translate}
            placeholder={`${translate.search}...`}
            value={filter?.search || ''}
          />
          {!!filterTextValues.length && (
            <FilterTextValues onDelete={(key) => resetFilter(key)} />
          )}

          {isOpenFilter && (
            <AsideFilter
              translate={translate}
              getFilterParams={updateFilter}
              config={filterCfg}
              filterValue={filter}
              onDropFilter={() => {
                updateFilter({})
                closeFilter()
              }}
            />
          )}
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.containerCards}>
          <div ref={containerRef} onScroll={handleScroll} className={st.cont}>
            <div className={st.cardsColumns}>
              <DragDropContext onDragEnd={handleDragEnd}>
                {visibleColumns.map((column, idx) => {
                  const isLastColumn = idx === visibleColumns.length - 1

                  return (
                    <Droppable
                      key={column.id}
                      droppableId={column.id.toString()}
                    >
                      {(provided, snapshot) => (
                        <ColumnDeals
                          provided={provided}
                          snapshot={snapshot}
                          filter={filterForColumns}
                          column={column}
                          dealsMap={dealsMap?.[column.id]}
                          setDealsMap={setDealsMap}
                          sortOrder={sortOrder}
                          totalMap={totalMap}
                          setTotalMap={setTotalMap}
                          page={page}
                          setPage={setPage}
                          funnelId={funnelId}
                          addNewDealModal={addNewDealModal}
                          translate={translate}
                          columns={visibleColumns}
                          isLastColumn={isLastColumn}
                          isSpecialColumn={isSpecialColumn(column.id)}
                          selectedDeals={selectedDeals}
                          toggleDealSelection={toggleDealSelection}
                          onSelectAllInColumn={handleSelectAllInColumn}
                        />
                      )}
                    </Droppable>
                  )
                })}
              </DragDropContext>
            </div>

            {isMergeModalOpen && (
              <MergeDealsForm
                dealsForMerge={dealsForAction}
                onClose={closeMergeModal}
                onMerge={handleMerge}
                translate={translate}
                funnelId={funnelId}
              />
            )}

            {isMassEditModalOpen && (
              <MassEditDealsForm
                dealsForEdit={dealsForAction}
                onClose={closeMassEditModal}
                onSave={handleMassEdit}
                translate={translate}
                funnelId={funnelId}
              />
            )}
          </div>
          {scrollWidth > clientWidth && (
            <div className={st.customScrollbarContainer}>
              <div
                className={st.customScrollbarTrack}
                onClick={handleTrackClick}
              >
                <div
                  ref={thumbRef}
                  className={st.customScrollbarThumb}
                  style={{
                    left: `${Math.min(
                      97,
                      (scrollLeft / (scrollWidth - clientWidth)) * 100,
                    )}%`,
                    cursor: isDragging ? 'grabbing' : 'grab',
                  }}
                  onMouseDown={handleThumbMouseDown}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default observer(Deals)
